<script>
  import { apiFetch } from "../../lib/api.js";
  import { user } from "../../stores/user";
  import { onMount } from "svelte";
  import getFecha from "../../services/fecha";
  import { BASE_URL } from "../../stores/BASE_URL";

  export let id_usuario = 0;
  let acciones = false;

  let isLoading = false;
  let isAdding = false;
  let contratos = [];

  let contratoNuevo = {
    id_operacion: 0,
    inicio: getFecha(),
    fin: getFecha(),
  };

  const addContrato = async () => {
    isAdding = true;
    const formData = new FormData();
    formData.append("id_usuario", id_usuario);
    formData.append("id_operacion", contratoNuevo.id_operacion);
    formData.append("inicio", contratoNuevo.inicio);
    formData.append("fin", contratoNuevo.fin);
    formData.append("action", "addContrato");
    formData.append("session_id_usuario", $user.idUsuario);

    const response = await apiFetch(`${BASE_URL}/cliente.php`, {
      method: "POST",
      body: formData,
    });

    const resp = await response.json();
    if (resp.status == "success") {
      getContratos();
    } else {
      alert(resp.message);
    }

    isAdding = false;
  };

  const getContratos = async () => {
    isLoading = true;
    const response = await apiFetch(`${BASE_URL}usuario.php?action=getContratos&id=${id_usuario}`);
    const resp = await response.json();
    contratos = resp.data;
    isLoading = false;
  };

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true });
    }

    getContratos();
    if ($user.rol == "administrador" || $user.rol == "operaciones") {
      acciones = true;
    }
  });
</script>

<div class="mb-2">
  <span class="col-form-label">Nro. Operacion / Fechas</span>
</div>

{#if acciones}
  <div class="mb-2 d-flex gap-2">
    <input type="number" class="form-control" bind:value={contratoNuevo.id_operacion} disabled />
    <input type="date" class="form-control" bind:value={contratoNuevo.inicio} />
    <input type="date" class="form-control" bind:value={contratoNuevo.fin} />
    {#if isAdding}
      <button class="btn btn-primary" disabled>Registrando...</button>
    {:else}
      <button class="btn btn-primary" on:click={addContrato}>Registrar</button>
    {/if}
  </div>
{/if}

<div class="table-responsive">
  <table class="table table-striped table-bordered table-sm small">
    <thead>
      <tr class="text-secondary fw-normal">
        <th>Operación</th>
        <th>Inicio</th>
        <th>Fin</th>
      </tr>
    </thead>
    <tbody>
      {#if !isLoading}
        {#each contratos as contrato}
          <tr>
            <td>{contrato.id_operacion}</td>
            <td>{contrato.inicio}</td>
            <td>{contrato.fin}</td>
          </tr>
        {/each}
      {/if}
    </tbody>
  </table>
</div>
